/*!
 * Copyright © 2026 Nail Alliance - North America, Inc.
 * Authors: See snippets/copyright-notices.liquid in the theme.
 * No other use is authorized without a written contract.
 */

(() => {
  const emitDialogState = (open) => {
    document.dispatchEvent(new CustomEvent(open ? 'theme:dialog-opened' : 'theme:dialog-closed'));
  };

  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;

      this.dialog = this.querySelector('[data-gallery-dialog]');
      this.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
        button.addEventListener('click', () => this.selectMedia(button.dataset.galleryThumb), { signal });
      });
      this.querySelectorAll('[data-gallery-dialog-thumb]').forEach((button) => {
        button.addEventListener('click', () => this.selectMedia(button.dataset.galleryDialogThumb), { signal });
      });
      this.querySelectorAll('[data-gallery-open]').forEach((button) => {
        button.addEventListener('click', () => this.open(button.dataset.galleryPanel), { signal });
      });
      this.querySelector('[data-gallery-close]')?.addEventListener('click', () => this.close(), { signal });
      this.dialog?.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      }, { signal });
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      }, { signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    selectMedia(mediaId) {
      if (!mediaId) return;
      const id = String(mediaId);

      this.querySelectorAll('[data-gallery-panel]').forEach((panel) => {
        const active = panel.dataset.galleryPanel === id;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      this.querySelectorAll('[data-gallery-dialog-panel]').forEach((panel) => {
        const active = panel.dataset.galleryDialogPanel === id;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      this.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
        const active = button.dataset.galleryThumb === id;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', String(active));
        if (active) button.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
      this.querySelectorAll('[data-gallery-dialog-thumb]').forEach((button) => {
        const active = button.dataset.galleryDialogThumb === id;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', String(active));
      });
    }

    open(mediaId) {
      if (!this.dialog || this.dialog.open) return;
      this.selectMedia(mediaId);
      this.dialog.showModal();
      emitDialogState(true);
      this.querySelector('[data-gallery-close]')?.focus({ preventScroll: true });
    }

    close() {
      if (!this.dialog?.open) return;
      this.dialog.close();
      emitDialogState(false);
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }
})();
